import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";

export const leadership: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.LEADERSHIP,
  label: "Leadership",
  kind: HtsTopicKind.Readiness,
  narrativeFields: [
    "the role (formal or informal), through work, volunteering, or extracurriculars",
    "how long it lasted",
    "a concrete example of what the candidate actually did while leading",
  ],
  followUpTriggers: [
    "a leadership title is claimed with no description of what the candidate actually did",
    "\"I led a project\" or similar with no concrete situation behind it",
  ],
  hardBarrierFacts: [],
};
